import { Component, OnInit, EventEmitter } from '@angular/core';
import { AlertService } from './alert.service';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})
export class AlertComponent implements OnInit {
  showAlert = false;
  eventEmitter: any; // actually of type EventEmitter
  alertClass = 'alert-primary';
  message = 'some message';

  constructor(private alertservice: AlertService) { }

  ngOnInit() {
    this.eventEmitter = this.alertservice.getEventEmitter();
    this.eventEmitter.subscribe(
      (result: any) => {
        this.alertClass = result.alertClass;
        this.message = result.message;
        this.showAlert = true;
      });
  }
}
